<template>
    <div>
        <simple-button look="primary" @click="toggleSortingMode(true)" icon="swap-vert">
            {{ $t('general.sort_button') }}
        </simple-button>

        <popup-modal
            custom-classes="w-624"
            v-if="showSortingPopup"
            @close="toggleSortingMode"
        >
            <div>
                <h1 class="first-letter:uppercase text-heading-2 font-semibold flex mb-12">
                    {{ $t('general.sort_button') }}
                </h1>
                <p class="mb-12">
                    {{ $t('general.sort_info') }}
                </p>
                <loading v-if="fetching" size="small"></loading>
                <draggable
                    v-bind="dragOptions"
                    v-else
                    v-model="sortingList"
                    handle=".draggable"
                    :item-key="item => groupId+'-'+item.id"
                    @end="updateOrder"
                    @start="drag = true"
                >
                    <template #item="{element, index}">
                        <div
                            class="draggable group cursor-move px-20 py-10 border w-full relative" :class="groupId"
                            :data-id="element.id"
                        >
                            <div
                                class="transition-all duration-100 absolute inset-y-0 left-0 w-0 group-hover:w-4"
                                :class="element.active === false ? 'bg-semantic-error' : 'bg-secondary-80'">
                            </div>

                            <div class="flex items-center mr-auto space-x-16 pr-40">
                                <strong class="text-heading-1" style="min-width: 30px"
                                        :class="element.active === false ? 'text-semantic-error' : 'text-secondary-80'">
                                    {{ index + 1 }}
                                </strong>

                                <svg-icon v-if="element.id === null" class="animate-spin w-16 h-16 mx-auto" size="small"
                                          type="loader"/>
                                <span v-html="element.label"></span>
                            </div>
                        </div>
                    </template>
                </draggable>
            </div>
        </popup-modal>
    </div>
</template>

<script>
import _debounce from "lodash/debounce";
import {mapState} from "pinia";
import {useMainStore} from '../state/store';
import SvgIcon from '../components/ui/SvgIcon.vue';
import PopupModal from "./ui/PopupModal";
import Loading from "./ui/Loading";
import Tooltip from "./navigation/Tooltip";
import Feature from "./Feature.vue";
import SimpleButton from "./ui/SimpleButton.vue";
import Draggable from "vuedraggable";
// VUE3_MIGRATION - temp fix for vuedraggable, compat issue
Draggable.compatConfig = { MODE: 3 }

export default {
    props: {
        groupId: String,
        fetchModels: Function,
    },
    components: {
        SimpleButton,
        SvgIcon,
        PopupModal,
        Loading,
        Tooltip,
        Feature,
        Draggable,
    },
    data: function () {
        return {
            showSortingPopup: false,
            sortingList: Array,
            fetching: false,
            drag: false,
        }
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        dragOptions() {
            return {
                animation: 200,
                group: this.groupId,
                disabled: false,
                ghostClass: 'ghost',
            };
        },
    },
    methods: {
        toggleSortingMode(show = false) {
            this.showSortingPopup = show;

            if (this.showSortingPopup) {
                this.fetching = true;

                this.fetchModels().then(result => {
                    this.sortingList = result;
                    this.fetching = false;
                });
            }
        },
        updateOrder: _debounce(function (evt) {
            this.drag = false;

            let sortOrders = Array.from(document.querySelectorAll('.' + this.groupId)).map((item, index) => ({
                id: item.dataset.id,
                sequence: index
            }));

            this.$emit('update', sortOrders);
        }, 500)
    }
}
</script>
